export default __webpack_public_path__ + "static/media/TassAppLogo.14c7f35d.svg";